import {
  type StoreExtensionContext,
  StoreExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import {
  AutomationBlockSchemaExtension,
  BrushHeadingBlockSchemaExtension,
  ElsterBlockSchemaExtension,
  GhostBlockSchemaExtension,
  StickyNoteBlockSchemaExtension,
  TrashcanBlockSchemaExtension,
  TutorialCardBlockSchemaExtension,
} from './schemas/index.js';

/**
 * StreamLain Store Extension
 *
 * Registers all StreamLain block schemas with the BlockSuite store.
 * New blocks should add their schema extension here.
 */
export class StreamLainStoreExtension extends StoreExtensionProvider {
  override name = 'affine-streamlain-block';

  override setup(context: StoreExtensionContext) {
    super.setup(context);

    // Register StreamLain block schemas
    context.register(AutomationBlockSchemaExtension);
    context.register(BrushHeadingBlockSchemaExtension);
    context.register(ElsterBlockSchemaExtension);
    context.register(GhostBlockSchemaExtension);
    context.register(StickyNoteBlockSchemaExtension);
    context.register(TrashcanBlockSchemaExtension);
    context.register(TutorialCardBlockSchemaExtension);
  }
}
